import type { CSSProperties } from 'react';
import InfoCircleFilledSvg from '../../assets/icons/info_circle_filled.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const InfoCircleFilled: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <InfoCircleFilledSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default InfoCircleFilled;
